export default [
    {
        name: 'listarTiposTarefasContabilidade',
        path: '/contabilidade/tipos_tarefas',
        alias: '/contabilidade/tipos_tarefas/index',
        component: () => import('../views/Listar')
    },
    {
        name: 'adicionarTipoTarefaContabilidade',
        path: '/contabilidade/tipos_tarefas/adicionar',
        component: () => import('../views/Adicionar')
    },
    {
        name: 'copiarTipoTarefaContabilidade',
        path: '/contabilidade/tipos_tarefas/adicionar/:id',
        component: () => import('../views/Adicionar')
    },
    {
        name: 'editarTipoTarefaContabilidade',
        path: '/contabilidade/tipos_tarefas/editar/:id',
        component: () => import('../views/Editar')
    },
    {
        name: 'visualizarTipoTarefaContabilidade',
        path: '/contabilidade/tipos_tarefas/visualizar/:id',
        component: () => import('../views/Visualizar')
    }
]
